export class Pivot {
    dataSource: any = {
        data: null
    };

    options: any = {
        grid: {
            type: "compact",
            title: "Untitled"
        },
        editing: false,
        configuratorActive: false,
        showDefaultSlice: false
    };

    conditions: any[] = [/*{
            formula: "#value < 50",
            measure: "Quantity",
            format: {
                backgroundColor: "#df3800",
                color: "#FFFFFF"
            },
            isTotal: false
        }, {
                formula: "#value > 100",
                measure: "Quantity",
                format: {
                    backgroundColor: "#00A45A",
                    color: "#FFFFFF"
                },
                isTotal: false
        }*/];

    formats: any[] = [{
            name: "2sfou03a",
            thousandsSeparator: ",",
            decimalSeparator: ".",
            decimalPlaces: 2,
        currencySymbolAlign: "left",
        nullValue: "",
        textAlign: "right",
        isPercent: false
    }]
}
